import styled from 'styled-components'

export const FormContainer = styled.form<{
  disabled?: boolean
  elementVisible: boolean
}>`
  width: 100%;
  max-width: 562.5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 24px;
  gap: 40px;
  background: linear-gradient(
    180deg,
    rgba(8, 237, 220, 0.1) 0%,
    rgba(8, 237, 220, 0.15) 50%,
    rgba(8, 237, 220, 0.1) 100%
  );
  box-shadow: ${({ elementVisible }) =>
    elementVisible
      ? '0px 0px 18px rgba(8, 237, 220, 0.5), 0px 0px 18px rgba(8, 237, 220, 0.1)'
      : '0px 0px 18px rgba(8, 237, 220, 0.1)'};
  border-radius: 32px;
  transition: all 0.5s ease-in-out;

  &.isFocus {
    background: linear-gradient(
      180deg,
      rgba(9, 168, 250, 0.1) 0%,
      rgba(9, 168, 250, 0.15) 50%,
      rgba(9, 168, 250, 0.1) 100%
    );
    box-shadow: 0px 0px 18px 0px rgba(9, 168, 250, 0.1),
      0px 0px 23px 8px rgba(9, 168, 250, 0.5);
  }

  .input-form {
    margin: 0;
    label {
      color: ${({ theme }) => theme.colors.primary};
      font-size: 14px;
      transition: all 0.3s ease-in-out;
    }
    input {
      border-color: ${({ theme }) => theme.colors.primary};
      color: ${({ theme }) => theme.colors.white};
      transition: all 0.3s ease-in-out;
    }

    span {
      color: #ff513a;
      font-weight: 500;
    }

    &.focus {
      label {
        color: ${({ theme }) => theme.colors.white};
      }
    }
  }

  .select-input {
    span {
      font-size: 14px;
    }
    p {
      color: #ff513a;
      font-weight: 500;
    }
    &.select-focus {
      span {
        color: ${({ theme }) => theme.colors.white};
      }
    }
  }

  .button-container {
    width: 100%;
    max-width: 100%;
    button {
      width: 100%;
      max-width: 100%;
    }

    &:hover {
      width: ${(props) => (props.disabled ? '100%' : '90%')};
    }
  }

  .h-input {
    display: none;
    nav-index: -1;
  }
`
